import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AuthReturnComponent } from './auth/auth-return/auth-return.component';
import { AuthUnauthorizedComponent } from './auth/auth-unauthorized/auth-unauthorized.component';

const routes: Routes = [
  // {
  //   path: '', pathMatch: "full",
  //   redirectTo: 'ogc'
  // },
  {
    path: 'ogc', loadChildren: () => import('./OGC/ogc.module').then(m => m.OGCModule),
    // canLoad: [AppMaintGuard],
    // canActivate: [AppAuthorizeGuard],
  },
  {
    path: 'cle', loadChildren: () => import('./CLE/cle.module').then(m => m.CleModule),
    // canLoad: [AppMaintGuard],
    // canActivate: [AppAuthorizeGuard],
  },
  {
    path: 'membership', loadChildren: () => import('./membership/membership.module').then(m => m.MembershipModule)
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'auth-return',
    component: AuthReturnComponent
  },
  {
    path: 'unauthorized',
    component: AuthUnauthorizedComponent
  },
  {
    path: '',
    component: HomeComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
